import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const MainPresupuestador = WithErrorBoundary(
  'Presupuestador',
  'Error en Presupuestador',
  React.lazy(() => import('./MainPresupuestador')),
)
const BudgetList = WithErrorBoundary(
  'Presupuestador',
  'Error en Lista de Presupuestos',
  React.lazy(() => import('./BudgetList')),
)

export default {
  path: '/presupuestador',
  name: 'Presupuestador',
  childRoutes: [
    { path: 'lista', name: 'Lista de presupuestos', component: BudgetList, isIndex: true },
    { path: 'crear', name: 'Main presupuestador', component: MainPresupuestador },
    { path: 'ultimo-editado', name: 'Main Presupuestador', component: MainPresupuestador },
    { path: 'editar/:id', name: 'Main presupuestador', component: MainPresupuestador },
    { path: 'ver/:id', name: 'Main presupuestador', component: MainPresupuestador },
    { path: 'simular', name: 'Main presupuestador', component: MainPresupuestador },
  ],
}
